import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (this.hasConsent()) {
      this.bannerTarget.remove()
    } else {
      this.bannerTarget.classList.remove("d-none")
    }
  }

  accept() {
    this.setCookie("cookie_consent", "accepted", 365)
    this.bannerTarget.classList.add("cookie-banner--hiding")
    setTimeout(() => this.bannerTarget.remove(), 300)
  }

  hasConsent() {
    return document.cookie.split("; ").some(c => c.startsWith("cookie_consent="))
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`
  }
}
